import React, { useState, useEffect } from 'react'
import HelpText from '../../HelpText'
import { FinancialSupportStatus, FinancialSupportStatusKeyByValue } from '../../../../enums/FinancialStatus';
import { getFinanceSupportContent, getFinanceSupportFormLink } from '../../../../services/reservoir';
import Loading from '../../Loading';
import parse from 'html-react-parser';

export const FinancialSupportCard = ({fundingInfo, citizenCode, courseLiabilityCategoryCode, course, handleError}) => {
  
  const [ isEligible, setIsEligible ] = useState(false);
  const [ content, setContent ] = useState(null);
  const [ header, setHeader ] = useState(null);
  const [ buttonSize, setButtonSize ] = useState(null);
  const [ displayButton, setDisplayButton ] = useState(false);
  const [ loading, setLoading ] = useState(true);
  const [ formLink, setFormLink ] = useState(null);
  const [ formLinkText, setFormLinkText ] = useState(null);
  const [ hasPostText, setHasPostText ] = useState(false);
  const [ postText, setPostText ] = useState(null);

  useEffect(()=>{
    getFinanceSupportContent(fundingInfo, true, citizenCode, courseLiabilityCategoryCode, course)
    .then(responseFundingType => {
      if (Array.isArray(responseFundingType) && responseFundingType.length !== 0) {
        let displayButton = responseFundingType[0].attributes.field_fs_display_button;
       
        setIsEligible(true);

        setContent(responseFundingType[0].attributes.body.value);
        setHeader(responseFundingType[0].attributes.field_financial_support_header.value);
        setButtonSize(responseFundingType[0].attributes.field_fs_button_size);
        setHasPostText(responseFundingType[0].attributes.field_fs_has_post_text)
        if (responseFundingType[0].attributes.field_fs_has_post_text) {
          setPostText(responseFundingType[0].attributes.field_fs_post_text.value)
        }

        if (displayButton) {
          getFinanceSupportFormLink(fundingInfo.fundingType)
          .then(responseFormLink => {
            setFormLink(responseFormLink[0].attributes.field_link.uri);
            setFormLinkText(responseFormLink[0].attributes.field_link.title);
            setLoading(false);
            setDisplayButton(displayButton);
          })
        } else {
          setLoading(false);
          setDisplayButton(displayButton);
        }
      } else {
        setLoading(false);
      }
    }
    ).catch(error => {
      handleError();
    });
  },[]);

  return (
    loading ? <Loading /> : (
      isEligible ? (
        <div className="question-group question-group-divider">
          <div className='financial-info'>
            {header ? parse(header) : null}

            {content ? parse(content) : null}
          </div>

          {
            displayButton ? (
              <div className="financial-content">
                <a className={`btn btn-financial-margin ${buttonSize} btn-primary center ${fundingInfo.status === FinancialSupportStatus.SUBMITTED || !formLink ? 'disabled-link' : ''}`} href={formLink}>
                  {formLinkText}
                </a>
              </div>
            ) : null
          }

          {
            hasPostText ? parse(postText) : null
          }
        </div>
      ) : null
    )
  ) 
}